var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightBulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#light_bulb_svg__clip0_3044_9961)",
    stroke: "#011E1E",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.324 9.573a4.325 4.325 0 10-6.177 3.9v2.277h3.706v-2.275a4.321 4.321 0 002.47-3.902z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 15.75h-1.5v1.5h1.5v-1.5z",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 9h-2.25M0 8.249h2.25M9 0v2.25M2.25 2.25l1.5 1.5M15.75 2.25l-1.5 1.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "light_bulb_svg__clip0_3044_9961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#fff"
  })))));
}
export default SvgLightBulb;